<template>
    <div class="Behavior">
        <div v-if="DisplayBxGrades">
            <div class="row">
                <h3>
                    Gradebook:
                </h3>
            </div>
            <div class="row">
                <h5>
                    Current Level (from prior week): {{ClientWeeklyGrades.GradeEarned != null ? ClientWeeklyGrades.GradeEarned.GradeEarned : {} }}
                </h5>
            </div>
            <div class="row">
                <h3>
                    <font-awesome-icon :icon="['fa', 'arrow-left']" @click="ChangeStartDate(-7)" class="pointer" /> <font-awesome-icon :icon="['fa', 'sync-alt']" @click="GetAllGrades()" class="olive-green-text pointer" />  <font-awesome-icon :icon="['fa', 'arrow-right']" @click="ChangeStartDate(7)" class="pointer" />
                </h3>
            </div>
            <div class="row" style="overflow-x:auto;">
                <table style="width:100%; margin-top: 15px;" class="table-striped table-hover">
                    <thead>
                        <tr class="center-cells">
                            <th style="border-style:none;"></th>
                            <th v-for="gradeDate in GetDateList" colspan="2">
                                {{ gradeDate.date }}
                            </th>
                        </tr>
                        <tr class="center-cells">
                            <th style="border-style:none;"></th>
                            <th v-for="gradeDate in GetDateList" colspan="2">
                                {{ gradeDate.day }}
                            </th>
                        </tr>
                        <tr class="center-cells">
                            <th style="border-style:none;"><button v-if="CheckPermission('CanUpdateClientGrades')" @click="GenerateDocuments" class="form-control btn btn-success" type="button">Generate Documents</button></th>
                            <th>
                                AM
                            </th>
                            <th>
                                PM
                            </th>
                            <th>
                                AM
                            </th>
                            <th>
                                PM
                            </th>
                            <th>
                                AM
                            </th>
                            <th>
                                PM
                            </th>
                            <th>
                                AM
                            </th>
                            <th>
                                PM
                            </th>
                            <th>
                                AM
                            </th>
                            <th>
                                PM
                            </th>
                            <th>
                                AM
                            </th>
                            <th>
                                PM
                            </th>
                            <th>
                                AM
                            </th>
                            <th>
                                PM
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="category in GradeCategories">
                            <td class="bold">{{ category.label }}</td>
                            <td class="center-text" v-for="clientCurrentGrade in ReturnClientCurrentGrades(category.name)">
                                <span v-if="clientCurrentGrade.clientNotPresent">
                                    NP
                                </span>
                                <span v-else-if="clientCurrentGrade.value != null">
                                    <IntegerEditor v-bind:old-value="clientCurrentGrade.value"
                                                   v-bind:record-id="clientCurrentGrade.gradeID"
                                                   v-bind:edit-mode="EditMode"
                                                   data-label="Edit Grade"
                                                   property-name="NewValue"
                                                   update-method="Residential/Clients/ClientGrades/UpdateSingleGradeValue"
                                                   :additional-payload="{ Category: category.name}"
                                                   v-bind:required="true"
                                                   @success="GetAllGrades()" />
                                </span>
                                <span v-else>

                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        
        <div class="row" style="margin-top:10px;">
            <h3>Target Behaviors:</h3>
        </div>
        <div class="row">
            <b-col>
                <TargetBehaviorEditor :record-id="ChildRecordData.Id" :edit-mode="EditMode" />
            </b-col>
            
        </div>
        <EditMode Permission="CanUpdateClientGrades" :EditMode="EditMode" @update-edit-mode="UpdateEditMode"/>
    </div>
</template>

<script>
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
    library.add(faArrowLeft);
    import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
    library.add(faArrowRight);
    import { faSyncAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faSyncAlt);
    import { faEdit } from '@fortawesome/free-solid-svg-icons';
    library.add(faEdit);
    import { faBed } from '@fortawesome/free-solid-svg-icons';
    library.add(faBed);
    import { faShower } from '@fortawesome/free-solid-svg-icons';
    library.add(faShower);
    import { faFutbol } from '@fortawesome/free-solid-svg-icons';
    library.add(faFutbol);
    import { faBook } from '@fortawesome/free-solid-svg-icons';
    library.add(faBook);
    import { faBriefcase } from '@fortawesome/free-solid-svg-icons';
    library.add(faBriefcase);
    import { faGraduationCap } from '@fortawesome/free-solid-svg-icons';
    library.add(faGraduationCap);
    import { faChild } from '@fortawesome/free-solid-svg-icons';
    library.add(faChild);
    import { faUser } from '@fortawesome/free-solid-svg-icons';
    library.add(faUser);
    import { faStethoscope } from '@fortawesome/free-solid-svg-icons';
    library.add(faStethoscope);
    import { faStar } from '@fortawesome/free-solid-svg-icons';
    library.add(faStar);
    import { faTimes } from '@fortawesome/free-solid-svg-icons';
    library.add(faTimes);
    import { faCheck } from '@fortawesome/free-solid-svg-icons';
    library.add(faCheck);
    //import components
    import IntegerEditor from '../../../Core/ItemEditors/IntegerEditor';
    import TargetBehaviorEditor from './TargetBehaviorEditor.vue';
    import EditMode from '../../../Core/ItemEditors/EditMode.vue';
    import { EventBus } from '../../../../services/event-bus.js';

    export default {
        props: [
            "ChildRecordData"
        ],
        data: function () {
            return {
                StartDate: "",
                ClientWeeklyGrades: [],
                EditMode: false,
                GradeCategories: [
                    {
                        name: "GradeWakeBed",
                        label: "Wakeup/Bedtime"
                    },
                    {
                        name: "GradeHygiene",
                        label: "Hygiene"
                    },
                    {
                        name: "GradePersonalSpace",
                        label: "Personal Space"
                    },
                    {
                        name: "GradeHouseRules",
                        label: "House Rules"
                    },
                    {
                        name: "GradeILS",
                        label: "ILS"
                    },
                    {
                        name: "GradeSchool",
                        label: "School"
                    },
                    {
                        name: "GradePeerRelations",
                        label: "Peer Relations"
                    },
                    {
                        name: "GradeAdultRelations",
                        label: "Adult Relations"
                    },
                    {
                        name: "GradeTreatment",
                        label: "Treatment"
                    },
                    {
                        name: "GradeTargetBehavior",
                        label: "Target Behavior"
                    }
                ]

            };
        },
        methods: {
            ChangeStartDate(magnitude) {
                this.StartDate = moment(this.StartDate, 'YYYY-MM-DD').add(magnitude, 'days').format("YYYY-MM-DD");
                this.GetAllGrades();
            },
            GenerateDocuments() {
                this.$MasterAPI.ExecuteRequest("POST", "Residential/Clients/ClientGrades/GenerateDocuments", { StartDate: this.StartDate, ClientSubProgramMembershipID: this.ChildRecordData.Id }, this.GenerateDocumentsSuccess, () => { }, true);
            },
            GenerateDocumentsSuccess(response) {
                alert("Your documents have been generated and will appear in the client's file");
            },
            ReturnClientCurrentGrades(gradeCategory) {
                let vm = this;
                let output = [];
                vm.GetDateList.forEach(function (dateItem) {
                    //GENERATE AM
                    let foundAM = false;
                    if (vm.ClientWeeklyGrades.ClientResidentialGrade != undefined) {
                        vm.ClientWeeklyGrades.ClientResidentialGrade.forEach(function (gradeItem) {
                            if (gradeItem.GradeDate == dateItem.compdate && gradeItem.AMPM == "AM") {
                                output.push({
                                    value: gradeItem[gradeCategory],
                                    gradeID: gradeItem.Id,
                                    category: gradeCategory,
                                    clientNotPresent: gradeItem.ClientNotPresent
                                });
                                foundAM = true;
                                //break;
                            }
                        });
                    }
                    if (foundAM == false) {
                        output.push({
                            value: null,
                            gradeID: null,
                            category: gradeCategory,
                            clientNotPresent: false
                        });
                    }
                    //GENERATE PM
                    let foundPM = false;
                    if (vm.ClientWeeklyGrades.ClientResidentialGrade != undefined) {
                        vm.ClientWeeklyGrades.ClientResidentialGrade.forEach(function (gradeItem) {
                            if (gradeItem.GradeDate == dateItem.compdate && gradeItem.AMPM == "PM") {
                                output.push({
                                    value: gradeItem[gradeCategory],
                                    gradeID: gradeItem.Id,
                                    category: gradeCategory,
                                    clientNotPresent: gradeItem.ClientNotPresent
                                });
                                foundPM = true;
                                //break;
                            }
                        });
                    }
                    if (foundPM == false) {
                        output.push({
                            value: null,
                            gradeID: null,
                            category: gradeCategory,
                            clientNotPresent: false
                        });
                    }
                });

                return output;
            },
            GetAllGrades() {
                this.$MasterAPI.ExecuteRequest("GET", "Residential/Clients/ClientGrades/GetGrades", { StartDate: this.StartDate, EndDate: moment(this.StartDate, "YYYY-MM-DD").add(6, "days").format("YYYY-MM-DD"), ClientSubProgramMembershipID: this.ChildRecordData.Id }, this.GetAllGradesSuccess, () => { }, false);
            },
            GetAllGradesSuccess(response) {
                response.data.data.ClientResidentialGrade.forEach(function(item) {
                    item.GradeDate = item.GradeDate.substring(0, 10);
                });
                this.ClientWeeklyGrades = response.data.data;
            },
            formatDate(value, fmt = 'MM/DD/YY', defaultText = '') {
                return (value == null)
                    ? defaultText
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            },
            UpdateEditMode() {
                this.EditMode = !this.EditMode;
            }
        },
        components: {
            IntegerEditor,
            TargetBehaviorEditor,
            EditMode
        },
        mounted() {
            //set current target date to the most previous Wednesday
            let dayOfWeek = parseInt(moment().format("e"));
            let dayOfWeekWedZero = dayOfWeek - 3;
            if (dayOfWeekWedZero < 0) {
                dayOfWeekWedZero = 7 + dayOfWeekWedZero;
            }
            this.StartDate = moment().add(dayOfWeekWedZero * -1, "days").format("YYYY-MM-DD");
            //Get Client Grades
            this.GetAllGrades();
        },
        computed: {
            GetDateList: function () {
                let startDate = this.StartDate;
                let dateOutput = []
                let weeks = ["Wed", "Thu", "Fri", "Sat", "Sun", "Mon", "Tue"];
                if (startDate) {
                    for (var i = 0; i < 7; i++) {
                        let nextDate = moment(startDate, 'YYYY-MM-DD').add(i, 'days').format('MM/DD/YY');
                        let compDate = moment(startDate, 'YYYY-MM-DD').add(i, 'days').format('YYYY-MM-DD');
                        dateOutput.push({
                            day: weeks[i],
                            date: nextDate,
                            compdate: compDate
                        });
                    }
                    return dateOutput;
                } else {
                    return []
                }
            },
            DisplayBxGrades: function () {
                if (this.ChildRecordData.SubProgramName == "Inland STRTP" || this.ChildRecordData.SubProgramName == "Hope Refuge") {
                    return true;
                } else {
                    return false;
                }
            }
        }    
    }
</script>

<style scoped>
    .top-margin-md {
        margin-top: 20px;
    }
    .top-margin-sm {
        margin-top: 12px;
    }
    .bottom-margin-sm {
        margin-bottom: 12px;
    }

    .center-cells td, .center-cells th {
        text-align: center;
    }

    table td, table th {
        border-style: solid;
    }
</style>